import { createFileRoute } from '@tanstack/react-router'
import ManagePermissions from 'pages/managePermissions/ManagePermissions'
import { z } from 'zod'

const manageUsersSearchSchema = z.object({
  mode: z.enum(['roles', 'users']).default('users'),
  user_id: z.string().optional(),
})

export const Route = createFileRoute('/admin/users')({
  component: ManagePermissions,
  staticData: {
    title: 'Manage Users',
  },
  validateSearch: manageUsersSearchSchema,
})
